import { createContext, useContext } from 'react';

export const LoginModalContext = createContext(null);
export const useLoginModal = () => useContext(LoginModalContext);
